/**
 * Rechten konden niet worden geladen (engine koud, 5xx). Vroeger: stille redirect naar Home,
 * wat leest als "ik heb ineens geen toegang" (P2, brede analyse 5 sep, FE-12).
 */
import { Alert, Box, Button } from '@mui/material';

export default function RechtenFout({ fout, opnieuw }) {
  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', mt: 6, px: 2 }}>
      <Alert severity="warning" action={<Button color="inherit" size="small" onClick={opnieuw} sx={{ textTransform: 'none', fontWeight: 700 }}>Opnieuw proberen</Button>}>
        Je rechten konden niet worden geladen{fout ? ` (${fout})` : ''}. De server start mogelijk nog op — probeer het zo opnieuw.
      </Alert>
    </Box>
  );
}
